export default __webpack_public_path__ + "static/media/logo.4fe8f2e7.svg";